var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5635 0H7.45005C6.658 0 6.01367 0.705094 6.01367 1.57174V5.26073H7.32487V1.57174C7.32487 1.49623 7.38104 1.43477 7.45005 1.43477H18.5635C18.6325 1.43477 18.6886 1.49623 18.6886 1.57174V13.7325C18.6886 13.808 18.6325 13.8695 18.5635 13.8695H15.2973V15.3043H18.5635C19.3555 15.3043 19.9998 14.5992 19.9998 13.7325V1.57174C19.9998 0.705094 19.3555 0 18.5635 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5498 6.6958H1.43642C0.644369 6.6958 0 7.4009 0 8.26759V20.4283C4.37068e-05 21.295 0.644369 22.0001 1.43642 22.0001H12.5498C13.3419 22.0001 13.9862 21.295 13.9862 20.4284V8.26759C13.9863 7.4009 13.3418 6.6958 12.5498 6.6958ZM12.5499 20.5653H1.43642C1.36737 20.5653 1.3112 20.5039 1.3112 20.4284V8.26759C1.3112 8.19203 1.36737 8.13057 1.43642 8.13057H12.5498C12.6189 8.13057 12.675 8.19203 12.675 8.26759V20.4284H12.6751C12.6751 20.5039 12.6189 20.5653 12.5499 20.5653Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.adc7484e66e7a1fd8eabc40d95a0fb82.svg";
export { ForwardRef as ReactComponent };